var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.188,
    height: 125.188,
    viewBox: "0 0 125.188 125.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-1153.598 -30.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(1153.598 30.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M379.388,12.749V0a62.647,62.647,0,0,0-14.526,1.9l3.3,12.317a49.88,49.88,0,0,1,11.226-1.466",
    transform: "translate(-317.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M164.34,79.082l-6.376-11.043a62.81,62.81,0,0,0-11.615,8.926l9.014,9.014a49.978,49.978,0,0,1,8.976-6.9",
    transform: "translate(-127.412 -59.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M85.98,155.364l-9.014-9.014a62.765,62.765,0,0,0-8.926,11.615l11.043,6.376a49.973,49.973,0,0,1,6.9-8.976",
    transform: "translate(-59.236 -127.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M264.359,30.391l-3.3-12.316a62.214,62.214,0,0,0-13.534,5.61L253.9,34.729a49.539,49.539,0,0,1,10.459-4.337",
    transform: "translate(-215.495 -15.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M30.391,589.813l-12.316,3.3a62.174,62.174,0,0,0,5.61,13.534l11.043-6.376a49.542,49.542,0,0,1-4.337-10.459",
    transform: "translate(-15.736 -513.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M12.749,490.314H0A62.647,62.647,0,0,0,1.9,504.84l12.317-3.3a49.88,49.88,0,0,1-1.466-11.226",
    transform: "translate(0 -426.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M14.215,368.162,1.9,364.862A62.653,62.653,0,0,0,0,379.388H12.749a49.88,49.88,0,0,1,1.466-11.226",
    transform: "translate(0 -317.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M18.075,261.065l12.316,3.3a49.54,49.54,0,0,1,4.337-10.459l-11.043-6.375a62.125,62.125,0,0,0-5.611,13.533",
    transform: "translate(-15.736 -215.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(1162.402 30.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M490.313,12.749a49.88,49.88,0,0,1,11.226,1.466l3.3-12.317A62.646,62.646,0,0,0,490.313,0Z",
    transform: "translate(-435.67)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M589.813,30.391a49.542,49.542,0,0,1,10.459,4.337l6.376-11.043a62.212,62.212,0,0,0-13.534-5.61Z",
    transform: "translate(-522.295 -15.736)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M820.661,600.272l11.043,6.376a62.147,62.147,0,0,0,5.611-13.533L825,589.813a49.54,49.54,0,0,1-4.337,10.459",
    transform: "translate(-723.271 -513.491)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M857.583,501.54l12.318,3.3a62.652,62.652,0,0,0,1.9-14.526h-12.75a49.878,49.878,0,0,1-1.466,11.226",
    transform: "translate(-755.415 -426.867)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M760.755,155.358a49.976,49.976,0,0,1,6.9,8.976l11.044-6.376a62.853,62.853,0,0,0-8.926-11.615Z",
    transform: "translate(-671.117 -127.406)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M857.583,368.162a49.879,49.879,0,0,1,1.466,11.226H871.8a62.653,62.653,0,0,0-1.9-14.526Z",
    transform: "translate(-755.415 -317.648)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M682.056,79.082a49.976,49.976,0,0,1,8.976,6.9l9.015-9.015a62.839,62.839,0,0,0-11.615-8.925Z",
    transform: "translate(-602.602 -59.235)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M825,264.36l12.317-3.3a62.163,62.163,0,0,0-5.611-13.533L820.661,253.9A49.538,49.538,0,0,1,825,264.36",
    transform: "translate(-723.271 -215.496)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M490.313,859.049V871.8a62.656,62.656,0,0,0,14.526-1.9l-3.3-12.318a49.878,49.878,0,0,1-11.226,1.466",
    transform: "translate(-435.67 -746.611)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M264.359,825a49.537,49.537,0,0,1-10.459-4.337L247.525,831.7a62.173,62.173,0,0,0,13.533,5.611Z",
    transform: "translate(-224.299 -714.467)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M379.388,859.049a49.879,49.879,0,0,1-11.226-1.466l-3.3,12.318a62.657,62.657,0,0,0,14.526,1.9Z",
    transform: "translate(-326.453 -746.611)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M589.813,825l3.3,12.317a62.141,62.141,0,0,0,13.533-5.611l-6.376-11.043A49.54,49.54,0,0,1,589.813,825",
    transform: "translate(-522.295 -714.467)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M691.032,760.756a49.988,49.988,0,0,1-8.976,6.9l6.376,11.044a62.812,62.812,0,0,0,11.615-8.926Z",
    transform: "translate(-602.602 -662.313)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M760.755,691.032l9.015,9.015a62.809,62.809,0,0,0,8.926-11.615l-11.044-6.376a49.983,49.983,0,0,1-6.9,8.976",
    transform: "translate(-671.117 -593.797)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M164.334,767.653a49.982,49.982,0,0,1-8.976-6.9l-9.015,9.015a62.847,62.847,0,0,0,11.615,8.926Z",
    transform: "translate(-136.211 -662.313)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M85.98,691.032a49.98,49.98,0,0,1-6.9-8.976L68.04,688.432a62.8,62.8,0,0,0,8.925,11.615Z",
    transform: "translate(-68.04 -593.797)",
    fill: "#e761a0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.949a5c7d5fb071511b00936f41acdc55.svg";
export { ForwardRef as ReactComponent };